import { User } from "../context/app";
import routesSecurity from "./routes-security";

export const checkIfHasAccessToRoute = (
  user: User,
  pathname: string,
): boolean => {
  const routeSecurity = routesSecurity.find((route) =>
    pathname.startsWith(route.path),
  );
  return (
    user.superuser ||
    !(routeSecurity && !routeSecurity.roles.some((role) => role === user?.role))
  );
};
